import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@excalidraw/excalidraw/index.css";
import "./app.css";

import { AuthGate } from "./components/AuthGate.jsx";
import { AdminPage } from "./pages/AdminPage.jsx";
import { BoardPage } from "./pages/BoardPage.jsx";
import { FolderPage } from "./pages/FolderPage.jsx";
import { HomePage } from "./pages/HomePage.jsx";
import { readStoredTheme } from "./ui/theme.js";

// Stamped before React mounts, so the first paint is already the right theme
// rather than a white flash on a dark machine.
const stored = readStoredTheme();
if (stored !== "system") document.documentElement.setAttribute("data-theme", stored);

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthGate>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/f/:folderId" element={<FolderPage />} />
          <Route path="/b/:boardId" element={<BoardPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthGate>
    </BrowserRouter>
  </React.StrictMode>,
);
